export function numberFormat(num) {
    return typeof num === 'number' ? num.toLocaleString() : num;
}